import { render, staticRenderFns } from "./BuyCodeManagement.vue?vue&type=template&id=5189ab55&scoped=true&"
import script from "./BuyCodeManagement.vue?vue&type=script&lang=js&"
export * from "./BuyCodeManagement.vue?vue&type=script&lang=js&"
import style0 from "./BuyCodeManagement.vue?vue&type=style&index=0&id=5189ab55&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5189ab55",
  null
  
)

export default component.exports